import {
  Box, FormControl, FormLabel, Select,
  Textarea,
} from '@chakra-ui/react';
import useUpdateField from '../useUpdateField';

const types = [
  { tag: 'h1', label: 'Heading 1' },
  { tag: 'h2', label: 'Heading 2' },
  { tag: 'p', label: 'Paragraph' },
];
const fontSizes = [
  { value: '4xl', label: '4xl' },
  { value: '3xl', label: '3xl' },
  { value: '2xl', label: '2xl' },
  { value: 'xl', label: 'xl' },
  { value: 'lg', label: 'lg' },
  { value: 'md', label: 'md' },
  { value: 'sm', label: 'sm' },
];
const typesFontSize = {
  h1: '2xl',
  h2: 'lg',
  p: 'md',
};
const TextOptions = ({ field }) => {
  const [tag, setTag] = useUpdateField(field, 'props.tag');
  const [fontSize, setFontSize] = useUpdateField(field, 'props.fontSize');
  const [text, setText] = useUpdateField(field, 'props.value');

  const handleChangeType = (e) => {
    const t = e.target.value;
    const fs = typesFontSize[t];
    setTag(t);
    setFontSize(fs);
  };

  return (
    <Box>
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Text</FormLabel>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} px="3" height="220px" />
      </FormControl>
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Tag</FormLabel>
        <Select value={tag} onChange={handleChangeType}>
          {types.map(({ tag: t, label }) => <option key={t} value={t}>{label}</option>)}
        </Select>
      </FormControl>
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Font size</FormLabel>
        <Select value={fontSize} onChange={(e) => setFontSize(e.target.value)}>
          {fontSizes.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TextOptions;
